import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import Header from '../components/HeaderHome';
const AboutPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <Header />

      {/* Contenu principal */}
      <main className="flex-grow bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="bg-white rounded-3xl shadow-lg p-8 md:p-12">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center">
              À Propos de SIND
            </h1>
            
            <div className="space-y-6 text-gray-600 leading-relaxed">
              <p className="text-lg">
                SIND est une plateforme innovante de cartographie des dépôts de médicaments, 
                née d'un partenariat stratégique entre Agence Nigérienne de Réglementation du secteur Pharmaceutique (ANRP)  
                et Lafia Iyali.
              </p>

              <div className="border-l-4 border-emerald-500 pl-6 my-8">
                <p className="text-xl font-semibold text-emerald-700">
                  Notre mission est de moderniser et d'optimiser la gestion des dépôts pharmaceutiques 
                  à travers le Niger.
                </p>
              </div>

              <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">
                Objectifs du Projet
              </h2>
              
              <ul className="list-disc pl-6 space-y-3">
                <li>Cartographier l'ensemble des dépôts pharmaceutiques du Niger</li>
                <li>Améliorer l'accès aux médicaments pour la population</li>
                <li>Faciliter la supervision et le contrôle des établissements pharmaceutiques</li>
                <li>Optimiser la distribution des médicaments sur le territoire national</li>
              </ul>

              <div className="bg-emerald-50 p-6 rounded-xl mt-8">
                <h3 className="text-xl font-semibold text-emerald-700 mb-4">
                  Partenariat ANRP - Lafia Iyali
                </h3>
                <p>
                  Cette collaboration unique entre l'ANRP et Lafia Iyali représente un pas important 
                  vers la digitalisation du secteur pharmaceutique au Niger. Elle combine l'expertise 
                  réglementaire de l'ANRP avec  Lafia Iyali.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
      {/* Footer */}
    
    </div>
  );
};

export default AboutPage;
